import React from 'react';
import { Route } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';

const AuthRoutes = (): React.ReactNode[] => [<Route key="login_callback" path="/login/callback" component={LoginCallback} />];

export default AuthRoutes;
